/* eslint-disable */

document.addEventListener('DOMContentLoaded', () => {
	// speichert welches Level 1 gerade ausgewählt ist
	let activeLevel1Id: string | null = null;

	document.querySelectorAll<HTMLElement>('.js-back-to-main-navigation').forEach((btn) => {
		btn.addEventListener('click', () => {
			// Level-2 Elemente des übergeordneten Level-1 zurücksetzen
			const level1 = btn.closest<HTMLElement>('.megamenu__level-1--element');
			if (!level1) return;

			level1
				.querySelectorAll<HTMLElement>('.megamenu__level-2--element')
				.forEach((el) => el.classList.remove('is-selected'));

			// Level-1 wieder als ausgewählt markieren
			level1.classList.add('is-selected');

			// activeLevel1Id setzen
			activeLevel1Id = level1.dataset.mainNavId || null;

			// Icon ggf. aktualisieren
			updateMenuIcon();
		});
	});

	document.addEventListener('click', (event) => {
		// Alle Klicks zentral abfangen
		const target = event.target as HTMLElement | null;
		if (!target) return;

		const crossBtn = document.querySelector('.js-back-to-main-navigation');
		const menuIcon = document.querySelector('.js-megamenu-toggle');
		const isMobile = window.innerWidth < 1279;

		// Menü togglen bei icn--search icon
		if (target.closest('.js-search-toggle')) {
			target.classList.toggle('is-open');
			updateMenuIcon(); // Icon aktualisieren
			return;
		}

		// Menü togglen bei icn--menu icon
		if (target.closest('.js-megamenu-toggle')) {
			toggleMenu();
			return;
		}

		// Öffnen eines Level-1-Elements (Megamenu)
		if (target.closest('.js-megamenu-toggle')) {
			toggleMenu();
		} else if (target.closest('.js-megamenu-open')) {
			const button = target.closest<HTMLElement>('.js-megamenu-open, .js-select-level-1');
			if (button?.dataset.mainNavId) {
				activeLevel1Id = button.dataset.mainNavId;
			}
			if (!button) return;

			// Bei geöffnetem Level 3 und Klick auf Level 0 zurücksliden
			document.querySelectorAll<HTMLElement>('.megamenu__level-2--element').forEach((element) => {
				element.classList.remove('is-selected');
			});

			if (button.dataset.mainNavId) {
				openMenu(button.dataset.mainNavId);
				activeLevel1Id = button.dataset.mainNavId; // speichern für Back Button
			} else {
				openMenu();
				activeLevel1Id = null;
			}
			// Klick auf Level-2-Element
		} else if (target.classList.contains('megamenu__level-2--element')) {
			document.querySelectorAll<HTMLElement>('.megamenu__level-2--element').forEach((element) => {
				element.classList.remove('is-selected');
			});
			target.classList.add('is-selected');
			// Klick auf Level-1-Element
		} else if (target.classList.contains('megamenu__level-1--element')) {
			document.querySelectorAll<HTMLElement>('.megamenu__level-2--element').forEach((element) => {
				element.classList.remove('is-selected');
			});
			document.querySelectorAll<HTMLElement>('.megamenu__level-1--element').forEach((element) => {
				element.classList.remove('is-selected');
			});
			target.classList.add('is-selected');
			activeLevel1Id = target.dataset.mainNavId || null; // <- hier speichern
			// Back-Button: Zurück zu Level 1
		} else if (target.closest('.js-back-to-main-navigation')) {
			document
				.querySelectorAll<HTMLElement>('.megamenu__level-2--element')
				.forEach((el) => el.classList.remove('is-selected'));

			let level1: HTMLElement | null = null;

			if (activeLevel1Id) {
				level1 = document.querySelector<HTMLElement>(
					`.megamenu__level-1--element[data-main-nav-id="${activeLevel1Id}"]`
				);
			}

			// Fallback: erstes Level-1-Element auswählen, falls activeLevel1Id nicht gesetzt
			if (!level1) {
				level1 = document.querySelector<HTMLElement>('.megamenu__level-1--element');
				if (level1) activeLevel1Id = level1.dataset.mainNavId || null;
			}

			level1?.classList.add('is-selected');
			return;
		}

		// Level 1 Trigger (z. B. .js-select-level-1)
		if (target.closest('.js-select-level-1')) {
			document
				.querySelectorAll<HTMLElement>('.megamenu__level-1--element')
				.forEach((el) => el.classList.remove('is-selected'));
			document
				.querySelectorAll<HTMLElement>('.megamenu__level-2--element')
				.forEach((el) => el.classList.remove('is-selected'));

			const parent = target.closest<HTMLElement>('.megamenu__level-1--element');
			parent?.classList.add('is-selected');
			activeLevel1Id = parent?.dataset.mainNavId || null; // <- hier speichern
			return;
		}

		// Trigger für Level 2 über spezifische Klasse (.js-select-level-2)
		if (target.closest('.js-select-level-2')) {
			const parent = target.closest<HTMLElement>('.megamenu__level-2--element');
			if (!parent) return;

			if (isMobile) {
				parent.classList.toggle('is-selected');
			} else {
				// DESKTOP: nur einmal setzen (kein Toggle)
				document
					.querySelectorAll<HTMLElement>('.megamenu__level-2--element')
					.forEach((el) => el.classList.remove('is-selected'));
				parent.classList.add('is-selected');
			}
			return;
		}
	});

	// Responsive Umschalten (Desktop → Mobile)
	let lastIsMobile = window.innerWidth < 1279;

	window.addEventListener('resize', () => {
		const isMobile = window.innerWidth < 1279;
		const megamenu = document.querySelector('.js-megamenu-expandable');
		const mobileNav = document.querySelector('.megamenu__mobile-nav');

		// Übergang von Desktop → Mobile
		if (!lastIsMobile && isMobile) {
			if (megamenu?.classList.contains('is-open')) {
				mobileNav?.classList.add('is-open');
			}
		}

		// Übergang von Mobile → Desktop
		if (lastIsMobile && !isMobile) {
			mobileNav?.classList.remove('is-open');
		}

		lastIsMobile = isMobile;
	});

	// Barrierefreiheit ohne Maus für Tab Schritte
	document
		.querySelectorAll('.js-select-level-1, .js-select-level-2, .js-back-to-main-navigation span')
		.forEach((span) => {
			span.setAttribute('tabindex', '0');
			span.setAttribute('role', 'button');

			span.addEventListener('keydown', function (e: KeyboardEvent) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					(this as HTMLElement).click();
				}
			});
		});

	// toggle Menü bei Klick auf icn--menu
	function toggleMenu(preselect: string | false = false) {
		const megamenu = document.querySelector('.js-megamenu-expandable');
		const mobileNav = document.querySelector('.megamenu__mobile-nav');
		if (!megamenu) return;

		const isMobile = window.innerWidth < 1279;

		if (megamenu.classList.contains('is-open')) {
			closeMenu();
			if (mobileNav && isMobile) mobileNav.classList.remove('is-open');
		} else {
			megamenu.classList.add('is-open');
			document.body.classList.add('no-body-scrolling');
			if (mobileNav && isMobile) mobileNav.classList.add('is-open');

			// Nur auf Mobile: erstes Level-1-Element automatisch auswählen
			if (isMobile && !preselect) {
				const firstLevel1 = megamenu.querySelector<HTMLElement>('.megamenu__level-1--element');
				if (firstLevel1) {
					firstLevel1.classList.add('is-selected');
					activeLevel1Id = firstLevel1.dataset.mainNavId || null;

					const level2 = firstLevel1.querySelector<HTMLElement>('.megamenu__level-2');
					if (level2) level2.classList.add('is-selected');
				}
			}

			if (preselect) {
				document
					.querySelectorAll<HTMLElement>('.megamenu__level-1--element')
					.forEach((el) => el.classList.remove('is-selected'));

				const item = megamenu.querySelector<HTMLElement>(
					`.megamenu__level-1--element[data-main-nav-id="${preselect}"]`
				);
				if (item) item.classList.add('is-selected');
			}
		}

		updateMenuIcon();
	}

	// Togglen von menu icon bei geöffneter/ geschlossener Navigation
	function updateMenuIcon() {
		const menuIcon = document.querySelector('.js-megamenu-toggle');
		if (!menuIcon) return;

		const megamenuOpen = document.querySelector('.js-megamenu-expandable')?.classList.contains('is-open');
		if (megamenuOpen) {
			menuIcon.classList.add('icn--group');
			menuIcon.classList.remove('icn--menu');
		} else {
			menuIcon.classList.remove('icn--group');
			menuIcon.classList.add('icn--menu');
		}
	}

	// Öffnen des Menüs
	function openMenu(preselect: string | false = false) {
		const megamenu = document.querySelector('.js-megamenu-expandable');
		if (!megamenu) return;

		megamenu.classList.add('is-open');
		document.body.classList.add('no-body-scrolling');

		if (preselect) {
			if (window.innerWidth < 1279) {
				document
					.querySelectorAll<HTMLElement>('.megamenu__level-1--element')
					.forEach((el) => el.classList.remove('is-selected'));

				const item = megamenu.querySelector<HTMLElement>(
					`.megamenu__level-1--element[data-main-nav-id="${preselect}"]`
				);
				if (item) item.classList.add('is-selected');

				const level2 = item.querySelector<HTMLElement>('.megamenu__level-2');
				if (level2) level2.classList.add('is-selected');
			} else {
				document
					.querySelectorAll<HTMLElement>('.megamenu__level-1--element')
					.forEach((el) => el.classList.remove('is-selected'));
				const item = megamenu.querySelector<HTMLElement>(
					`.megamenu__level-1--element[data-main-nav-id="${preselect}"]`
				);
				if (item) item.classList.add('is-selected');
			}
		}
	}

	// Schließen des Menüs
	function closeMenu() {
		const megamenu = document.querySelector('.js-megamenu-expandable');
		const mobileNav = document.querySelector('.megamenu__mobile-nav');
		if (!megamenu) return;

		megamenu.classList.remove('is-open');
		mobileNav?.classList.remove('is-open');
		document.body.classList.remove('no-body-scrolling');

		document.querySelectorAll<HTMLElement>('.is-selected').forEach((el) => el.classList.remove('is-selected'));
		updateMenuIcon();
	}

	// Mobile-Nav: Erster Unterpunkt als default + Untermenü öffnen
	function selectMobileLevel1(btn: HTMLButtonElement) {
		const isMobile = window.innerWidth < 1279;
		if (!isMobile) return; // nur Mobile

		// Alle Buttons und Level-2-Menüs zurücksetzen
		document.querySelectorAll<HTMLButtonElement>('.megamenu__mobile-nav button.js-megamenu-open').forEach((b) => {
			b.classList.remove('is-selected');
			const lvl2 = b.nextElementSibling as HTMLElement | null;
			if (lvl2?.classList.contains('megamenu__level-2')) {
				lvl2.classList.remove('is-selected');
			}
		});

		// Aktuellen Button markieren + Untermenü öffnen
		btn.classList.add('is-selected');
		activeLevel1Id = btn.dataset.mainNavId || null;

		const level2 = btn.nextElementSibling as HTMLElement | null;
		if (level2?.classList.contains('megamenu__level-2')) {
			level2.classList.add('is-selected');
		}
	}

	// Per default erstes Level direkt markieren (nur Mobile)
	function openFirstLevelOnMobile() {
		const isMobile = window.innerWidth < 1279;
		if (!isMobile) return;

		const firstButton = document.querySelector<HTMLButtonElement>(
			'.megamenu__mobile-nav--list li button.js-megamenu-open'
		);
		if (!firstButton) return;

		// Wenn schon markiert, nichts tun
		if (document.querySelector('.megamenu__mobile-nav button.is-selected')) return;

		selectMobileLevel1(firstButton);
	}

	// Direkt beim Laden ausführen
	openFirstLevelOnMobile();

	// Klick-Handler für alle Mobile-Level-1-Buttons
	document
		.querySelectorAll<HTMLButtonElement>('.megamenu__mobile-nav--list li button.js-megamenu-open')
		.forEach((btn) => {
			btn.addEventListener('click', () => selectMobileLevel1(btn));
		});

	// Menü öffnet sich sofort beim ersten Klick, auch bei #anchor Links
	document.querySelectorAll('.js-megamenu-open').forEach((link) => {
		link.addEventListener('click', (e) => {
			const isMobile = window.innerWidth < 1279;

			if (isMobile) return;

			e.preventDefault();
			toggleMenu();

			const href = link.getAttribute('href');
			if (href && href.startsWith('#')) {
				history.replaceState(null, '', href);
			}
		});
	});

	// Wenn Anker auf gleicher Seite aufgerufen wird, muss Navi schließen
	window.addEventListener('hashchange', () => {
		closeMenu();
	});
});
